module.exports = __webpack_public_path__ + "e767582aee7155c95ee0ef841f314964.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/tokyo.jpg
// module id = 649
// module chunks = 47